export class ReasonDto {
    public reason: string;

    constructor(reason: string) {
        this.reason = reason;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/reasonDto.ts